import { motion } from "framer-motion";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { GoldButton } from "@/components/primitives";
import CTABlock from "@/components/CTABlock";
import { frameworkStages } from "@/data/content";

export default function Framework() {
  return (
    <div data-testid="framework-page">
      <PageHero
        testId="framework-page-hero"
        label="The Fortuna Strive Framework"
        title="Growth does not break businesses."
        accent="Weak systems do."
        subtitle="Businesses often assume they need more marketing, more tools, or more people. The real issue is usually structural: the offer, sales process, delivery system, or operating model has not been built for the next stage."
      />

      <section className="border-t border-fs-border bg-fs-bg2 py-20 lg:py-28">
        <div className="fs-shell">
          <div className="space-y-6">
            {frameworkStages.map((stage, i) => (
              <Reveal key={stage.number} delay={i * 0.05}>
                <div
                  data-testid={`framework-stage-${stage.number}`}
                  className="group grid gap-8 border border-fs-border bg-fs-card p-8 transition-colors duration-300 hover:border-fs-gold/40 lg:grid-cols-12 lg:p-12"
                >
                  <div className="lg:col-span-1">
                    <span className="font-serif text-5xl font-light text-fs-gold/60 transition-colors duration-300 group-hover:text-fs-gold">
                      {stage.number}
                    </span>
                  </div>
                  <div className="lg:col-span-6">
                    <h2 className="font-serif text-2xl font-normal leading-snug text-fs-ink sm:text-3xl">
                      {stage.title}
                    </h2>
                    <p className="mt-6 text-xs uppercase tracking-[0.24em] text-fs-gold">
                      Focus
                    </p>
                    <ul className="mt-4 space-y-2">
                      {stage.focus.map((f) => (
                        <li key={f} className="flex items-center gap-3 text-sm text-fs-muted">
                          <span className="h-1 w-1 rotate-45 bg-fs-gold/70" />
                          {f}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="lg:col-span-5 lg:border-l lg:border-fs-border lg:pl-10">
                    <p className="text-xs uppercase tracking-[0.24em] text-fs-gold">
                      Primary objective
                    </p>
                    <p className="mt-4 font-serif text-xl font-light leading-snug text-fs-ink sm:text-2xl">
                      {stage.objective}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal>
            <div className="mt-16 text-center">
              <p className="mx-auto max-w-2xl fs-body">
                Every stage requires a different focus. We help you identify where
                your business is now — and build the systems required to reach the next.
              </p>
              <div className="mt-8 flex justify-center">
                <GoldButton to="/contact" variant="solid" testId="framework-cta">
                  Find Your Stage
                </GoldButton>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <CTABlock />
    </div>
  );
}
